export const buildPLPPaginationUrl = (
  pathname: string,
  queryParamsString: string,
  number?: number,
) => {
  let newPathname = pathname;
  if (number) {
    if (number > 1) {
      if (!newPathname.includes('/page')) {
        newPathname += `/page/${number}`;
      } else {
        newPathname = newPathname.replace(/\/page\/\d+(?=[/?]|$)/, `/page/${number}`);
      }
    }
    if (number === 1) {
      if (newPathname.includes('/page')) {
        // If number is 1 and pathname contains '/page/', remove it
        newPathname = newPathname.replace(/\/page\/\d+(?=[/?]|$)/, '');
      }
    }
    return `${newPathname}${queryParamsString.length ? `?${queryParamsString}` : ''}`;
  }
  // number parameter are undefined for ellipsis and arrows
  return '';
};
